import { QueryClient, QueryClientProvider, QueryCache } from "react-query";
import useFeedback from "./components/feedback/useFeedback";
import { useState, useEffect } from "react";
import { getSessionStatus } from "./shared/keycloak";

function CustomQueryClientProvider({ children }) {
  const { showError } = useFeedback();

  function onError(error) {
    error.isRequestError &&
      showError(error, { persist: false, preventDuplicate: true });
  }

  const [queryClient] = useState(
    () =>
      new QueryClient({
        queryCache: new QueryCache({ onError }),
        defaultOptions: {
          queries: {
            retry: (count, error) =>
              ![401, 403, 400, 404].includes(error?.status) && count < 1
          },
          mutations: { retry: false }
        }
      })
  );
  useEffect(() => {
    const clear = () => {
      const s = getSessionStatus();
      if (!s.hasAccess) {
        queryClient.cancelQueries();
        queryClient.clear();
      }
    };
    window.addEventListener("esocial-session", clear);
    return () => window.removeEventListener("esocial-session", clear);
  }, [queryClient]);

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}

export default CustomQueryClientProvider;
